module.exports = __webpack_public_path__ + "static/fonts/Nunito-BoldItalic.378711d.woff";